/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Callout_2_LabelInputs */

const en_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitive players`)
};

const es_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugadores competitivos`)
};

const de_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnierspieler`)
};

const zh_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`竞技球员`)
};

const ar_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللاعبون التنافسيون`)
};

const fr_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joueurs de compétition`)
};

const vi_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người chơi cạnh tranh`)
};

const sw_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachezaji wa ushindani`)
};

const th_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นักกอล์ฟสายแข่งขัน`)
};

const bs_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takmičarski igrači`)
};

const ja_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`競技志向のプレーヤー`)
};

const ko_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대회에 나서는 선수`)
};

const pt_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogadores competitivos`)
};

const it_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agonisti`)
};

const sv_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tävlingsspelare`)
};

const nl_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijdspelers`)
};

const da_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konkurrencespillere`)
};

const nb_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konkurransespillere`)
};

const fi_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilpapelaajat`)
};

const pl_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zawodnicy turniejowi`)
};

const ru_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Турнирные игроки`)
};

const tr_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnuva oyuncuları`)
};

const hi_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतियोगी खिलाड़ी`)
};

const id_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain kompetitif`)
};

const ms_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain kejohanan`)
};

const cs_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnajoví hráči`)
};

const el_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αγωνιστικοί παίκτες`)
};

const he_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שחקנים תחרותיים`)
};

const af_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompeterende spelers`)
};

const hu_injury_content_callout_2_label = /** @type {(inputs: Injury_Content_Callout_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versenyképes játékosok`)
};

/**
* | output |
* | --- |
* | "Competitive players" |
*
* @param {Injury_Content_Callout_2_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_callout_2_label = /** @type {((inputs?: Injury_Content_Callout_2_LabelInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Callout_2_LabelInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_callout_2_label(inputs)
	if (locale === "de") return de_injury_content_callout_2_label(inputs)
	if (locale === "zh") return zh_injury_content_callout_2_label(inputs)
	if (locale === "ar") return ar_injury_content_callout_2_label(inputs)
	if (locale === "fr") return fr_injury_content_callout_2_label(inputs)
	if (locale === "vi") return vi_injury_content_callout_2_label(inputs)
	if (locale === "sw") return sw_injury_content_callout_2_label(inputs)
	if (locale === "th") return th_injury_content_callout_2_label(inputs)
	if (locale === "bs") return bs_injury_content_callout_2_label(inputs)
	if (locale === "ja") return ja_injury_content_callout_2_label(inputs)
	if (locale === "ko") return ko_injury_content_callout_2_label(inputs)
	if (locale === "pt") return pt_injury_content_callout_2_label(inputs)
	if (locale === "it") return it_injury_content_callout_2_label(inputs)
	if (locale === "sv") return sv_injury_content_callout_2_label(inputs)
	if (locale === "nl") return nl_injury_content_callout_2_label(inputs)
	if (locale === "da") return da_injury_content_callout_2_label(inputs)
	if (locale === "nb") return nb_injury_content_callout_2_label(inputs)
	if (locale === "fi") return fi_injury_content_callout_2_label(inputs)
	if (locale === "pl") return pl_injury_content_callout_2_label(inputs)
	if (locale === "ru") return ru_injury_content_callout_2_label(inputs)
	if (locale === "tr") return tr_injury_content_callout_2_label(inputs)
	if (locale === "hi") return hi_injury_content_callout_2_label(inputs)
	if (locale === "id") return id_injury_content_callout_2_label(inputs)
	if (locale === "ms") return ms_injury_content_callout_2_label(inputs)
	if (locale === "cs") return cs_injury_content_callout_2_label(inputs)
	if (locale === "el") return el_injury_content_callout_2_label(inputs)
	if (locale === "he") return he_injury_content_callout_2_label(inputs)
	if (locale === "af") return af_injury_content_callout_2_label(inputs)
	if (locale === "hu") return hu_injury_content_callout_2_label(inputs)
	return en_injury_content_callout_2_label(inputs)
});